import { LicenseInfo } from '@mui/x-license-pro';

var setupMuiLicense = function setupMuiLicense() {
  var hasNotSetLicense = !LicenseInfo.getLicenseKey();
  var hasSetProLicense = LicenseInfo.getLicenseKey() && LicenseInfo.getLicenseKey() === "89364593cd0d665763625385ab46df1fTz02ODYyNSxFPTE3MTgzNTQ0NDMwMTEsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=";
  var shouldSetPremiumLicense = hasNotSetLicense || hasSetProLicense;
  if (shouldSetPremiumLicense && "8378d4dd2c496f5914b9b903e7c0f444Tz0xMDk4NjksRT0xNzczODc4Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y") {
    LicenseInfo.setLicenseKey("8378d4dd2c496f5914b9b903e7c0f444Tz0xMDk4NjksRT0xNzczODc4Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y");
  }
};

export { setupMuiLicense };
